import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import * as Authentication from "./reducers/authReducer";
import * as SelfService from "./reducers/selfServiceReducer";
import * as StaticData from "./reducers/staticDataReducer";
import reduxImmutableStateInvariant from "redux-immutable-state-invariant";
import thunk from "redux-thunk";
import { routerReducer } from "react-router-redux";

export default function configureStore(initialState) {
  const reducers = {
    authentication: Authentication.reducer,
    selfService: SelfService.reducer,
    staticData: StaticData.reducer,
  };

  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; // add support for Redux dev tools

  const rootReducer = combineReducers({
    ...reducers,
    routing: routerReducer,
  });

  return createStore(
    rootReducer,
    initialState,
    composeEnhancers(applyMiddleware(thunk, reduxImmutableStateInvariant()))
  );
}
